<div class="mb-3">
  <div>Workflow was generated with id:</div>
  <p-button [link]="true" [label]="generatedWorkflowId" [autofocus]="false" severity="secondary"></p-button>
</div>
<div class="flex flex-row-reverse">
  <p-button label="Go to workflow" severity="success" (click)="navigateToGeneratedWorkflow()"></p-button>
</div>
